export default "__VITE_ASSET__G_Sd5WrR__"